// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  lead: __t.identity(),
  name: __t.string(),
  planningWindowS: __t.u32().name("planning_window_s"),
  allowPausing: __t.bool().name("allow_pausing"),
  createdAt: __t.timestamp().name("created_at"),
  state: __t.u8(),
  encounterId: __t.option(__t.u64()).name("encounter_id"),
  scenario: __t.u8(),
});
